import React, { useRef } from 'react'
import { motion } from 'framer-motion'
import Inputtt from '../SelectValue/Inputtt'
import Textarea from '../SelectValue/TextArea'
import Button from '../SelectValue/Button'
import Loc from '../../images/mail9.svg'
import Phone from '../../images/spp.svg'
import emailjs from '@emailjs/browser';
import AnimateIn from '../AnimateIn'

function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_kp9f3we', 'template_ll1oyye', form.current, {
        publicKey: 'j0bW3spkUUTiiSbbo',
      })
      .then(
        () => {
          alert('Mail sent')
          window.location.reload();
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };

  return (
    <div id='contact' className='sm:pt-[96px] sm:px-[90px] sm:pb-[60px] pb-[24px] px-8 pt-[48px] overflow-hidden'>
      <AnimateIn from="left">
        <h1 className='font-[900] text-[#343373] sm:text-[64px] text-start text-[32px]'>Contact us</h1>
      </AnimateIn>

      <div className='grid sm:grid-cols-3 gap-6 mx-auto'>
        <AnimateIn from="left" delay={0.2} className='mt-5'>
          <p className='font-[700] text-[20px] mb-3'>Call us</p>
          <motion.div
            className='flex gap-3 mb-3'
            whileHover={{ x: 5 }}
            transition={{ duration: 0.2 }}
          >
            <img src={Phone} alt='Phone' height={20} width={20} className='inline-block'/>
            <p className='font-[400] text-[#343373]'>1-647-718-9675</p>
          </motion.div>
          <motion.div
            className='flex gap-3 mb-3'
            whileHover={{ x: 5 }}
            transition={{ duration: 0.2 }}
          >
            <img src={Loc} alt='Mail' height={20} width={20} className='inline-block'/>
            <p className='font-[400] text-[#343373]'>info@kelenservices.com</p>
          </motion.div>
        </AnimateIn>

        <AnimateIn from="right" delay={0.3} className='sm:col-span-2 sm:w-[75%]'>
          <form ref={form} onSubmit={sendEmail}>
            <Inputtt label={'Name'} name={'name'} />
            <Inputtt label={'Email address'} name="email_id" />
            <Inputtt label={'Subject'} name="subject" />
            <Textarea label={'Message'} name="message" />
            <div className='grid grid-cols-1 mt-7'>
              <Button name={'Send'} />
            </div>
          </form>
        </AnimateIn>
      </div>
    </div>
  )
}

export default Contact
